import { isDefined } from "@omni/utils/helper.utils";
import { parseFloatSafe } from "@omni/utils/number.utils";
import queryString from "query-string";
import { PureComponent } from "react";

import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";
import { asyncState } from "@/utils/calculators";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

type TileCalculatorState = {
    roomLength: string;
    roomWidth: string;
    roomArea: number;
    tileWidth: string;
    tileLength: string;
    tileArea: number;
    packageArea: string;
};

class TileCalculator extends PureComponent<{}, TileCalculatorState> {
    query = queryString.parse(location.search);

    constructor(props: {}) {
        super(props);

        this.state = {
            roomLength: this.query.roomLength?.toString() || "0",
            roomWidth: this.query.roomWidth?.toString() || "0",
            tileWidth: this.query.tileWidth?.toString() || "0",
            tileLength: this.query.tileLength?.toString() || "0",
            packageArea: this.query.packageArea?.toString() || "0",
            roomArea: 0,
            tileArea: 0
        };
    }

    async componentDidMount() {
        await asyncState(this, {
            roomArea: this.roomArea(),
            tileArea: this.tileArea()
        });

        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.tile);
    }

    // calculations
    roomArea = () => {
        let roomArea = 0;

        const roomLength = parseFloatSafe(this.state.roomLength);

        const roomWidth = parseFloatSafe(this.state.roomWidth);

        if (isDefined(roomLength) && isDefined(roomWidth)) {
            roomArea = roomLength * roomWidth;
        }

        return roomArea;
    };
    tileArea = () => {
        let tileArea = 0;

        const tileLength = parseFloatSafe(this.state.tileLength);

        const tileWidth = parseFloatSafe(this.state.tileWidth);

        if (isDefined(tileLength) && isDefined(tileWidth)) {
            tileArea = tileLength * tileWidth * 0.01 * 0.01;
        }

        return Number(tileArea);
    };

    // setters
    setCalculationValue = (field: string, value: string) => {
        this.setState(
            (state) => ({ ...state, [field]: value }),
            () => {
                this.setState({
                    roomArea: this.roomArea(),
                    tileArea: this.tileArea()
                });
            }
        );

        CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.tile);
    };

    render() {
        const calculationProps = {
            setCalculationValue: this.setCalculationValue,
            roomLength: this.state.roomLength,
            roomWidth: this.state.roomWidth,
            tileWidth: this.state.tileWidth,
            tileLength: this.state.tileLength,
            packageArea: this.state.packageArea
        };
        const resultProps = {
            roomArea: this.state.roomArea,
            tileArea: this.state.tileArea,
            packageArea: parseFloatSafe(this.state.packageArea, 0),
            mailParams: {
                roomLength: this.state.roomLength,
                roomWidth: this.state.roomWidth,
                tileWidth: this.state.tileWidth,
                tileLength: this.state.tileLength,
                packageArea: this.state.packageArea
            }
        };

        return (
            <div id="calculator">
                <Calculation {...calculationProps} />
                <Result {...resultProps} />
            </div>
        );
    }
}

export { TileCalculator };
